/**
 * Aspect Ratio Class Generator
 * Adds only necessary classes
 */

(function() {
  'use strict';

  // breakpoint order mobile-first
  const breakpointOrder = ['xs', 'sm', 'md', 'lg', 'xl', 'xxl'];

  /**
   * Normalize aspect ratio string to class name
   * "16:9" -> "16-9"
   */
  function normalizeRatio(ratio) {
    return ratio.replace(':', '-');
  }

  /**
   * Generates an optimized class list for an element
   */
  function generateClasses(ratiosData) {
    const classes = [];
    let previousRatio = null;

    // Go through the breakpoints in order
    breakpointOrder.forEach(breakpoint => {
      const currentRatio = ratiosData[breakpoint];

      // Add class only if the ratio changes.
      if (currentRatio && currentRatio !== previousRatio) {
        const normalizedRatio = normalizeRatio(currentRatio);
        classes.push(`aspect-ratio-${breakpoint}-${normalizedRatio}`);
        previousRatio = currentRatio;
      }
    });

    return classes;
  }

  /**
   * Processes all elements with data-aspect-ratio
   */
  function applyAspectRatioClasses() {
    const elements = document.querySelectorAll('[data-aspect-ratio]');

    elements.forEach(element => {
      const dataAttr = element.getAttribute('data-aspect-ratio');

      if (!dataAttr) {
        return;
      }

      try {
        const ratiosData = JSON.parse(dataAttr);
        const classes = generateClasses(ratiosData);

        // remove old aspect-ratio classes
        element.className = element.className
          .split(' ')
          .filter(cls => !cls.startsWith('aspect-ratio-'))
          .join(' ');

        // Add new classes
        if (classes.length > 0) {
          element.classList.add(...classes);
        }
      } catch {
        console.warn('Error while parsing data-aspect-ratio:', element);
      }
    });
  }

  /**
   * Initialization
   */
  function init() {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', applyAspectRatioClasses);
    } else {
      applyAspectRatioClasses();
    }
  }
  init();
})();
